export const Page404 = () => {

    // タイトル設定
    document.title = "404NotFound | EarthUnity"
    
    return (
        <div>
            <div style={{textAlign: "center", width: "100%"}}>
                <img src="/images/404/Creeper-404.png" style={{width: "clamp(18px, 100vw, 1000px)"}} />
            </div>
        </div>
    );
}  